import { render, staticRenderFns } from "./202301.vue?vue&type=template&id=65dfae14&scoped=true&"
import script from "./202301.vue?vue&type=script&lang=js&"
export * from "./202301.vue?vue&type=script&lang=js&"
import style0 from "./202301.vue?vue&type=style&index=0&id=65dfae14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfae14",
  null
  
)

export default component.exports